import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withSearch } from '../SearchContext'
import MediaQuery from 'react-responsive'
import { withAuth } from '../AuthContext'
import { strLimit } from '../../utils/utils'
import { Menu } from '../Dashboard/Menu'
import { INFO } from '../../utils/constants'
import Notification from '../Utils/Notification'
import Cookies from 'universal-cookie'
import {
  setPricing,
  textTranslation,
  shouldTranslateTo,
} from '../../utils/utils'
import { decode } from 'html-entities'
import Popup from './Popup'

const cookies = new Cookies()

// react responsive from https://www.npmjs.com/package/react-responsive
// sticky block https://webdesign.tutsplus.com/tutorials/sticky-positioning-with-nothing-but-css--cms-24042
class User extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user: {
        languages: [],
      },
      place: {},
      priceData: null,
      userData: null,
      popupContent: null,
    }

    this.handleSendMessage = this.handleSendMessage.bind(this)
  }

  componentDidMount() {
    const getPricing = async () => {
      const data = await setPricing(cookies.get('cV'), cookies.get('dC'))
      this.setState({
        priceData: data.membershipFee.toString(),
      })
      const u = this.state.user

      var pageData = [
        'Edit profile', //0
        'Hello, I' + decode('&#39;') + 'm',
        'I’m a host',
        'I’m a local',
        'From',
        'Some fields are hidden. Full profiles are only visible to members. Click here to',
        'join', //6
        'log-in',
        'About me',
        u.introduction !== null ? u.introduction : '',
        'Interests', //10
        u.interest !== null ? u.interest : '',
        'My Philosophy of Life',
        u.philosophy !== null ? u.philosophy : '',
        'Languages spoken',
        'Place I most want to visit', //15
        u.favoPlace !== null ? u.favoPlace : '',
        'Best places I' + decode('&#39;') + 've visited',
        u.favoVisitedPlace !== null ? u.favoVisitedPlace : '',
        'My favourites',
        'Book or author', //20
        'Actor or actress',
        'Film',
        'Food',
        'Musician or band',
        'Sport', //25
        'Ideal dinner guest (of all time)',
        'Thinking of visiting ' + u.city + '?',
        'Click on the button below to view messages that have been sent to you.',
        'Check Your Messages',
        'You can message ' +
          u.forename +
          ' for local advice, tips or to arrange a meet-up if you become a Freebird Club member. Membership costs only ' +
          decode(cookies.get('cS') + this.state.priceData) +
          ' per year.',
        'Tell me more', //31
        'Join Freebird Club',
        'If you would like to get local advice or tips from ' +
          u.forename +
          ', or maybe even meet up when there, get in touch!',
        u.forename + ' has requested contact from women only please.',
        u.forename + ' has requested contact from men only please.', //35
        'Message ' + u.forename,
        'Stay at my place',
        '"Homestays are a chance to get to know your host & immerse yourself in local culture. Check out your hosts place. They' +
          decode('&#39;') +
          're looking forward to welcoming you."',
        this.state.place.description,
        'View place', //40
        'No place listing',
        u.forename +
          ' doesn' +
          decode('&#39;') +
          't have a place listed for homestays. Check out our homestay listings for places to stay.',
        'Find homestays',
      ]

      var popupPageData = [
        'Freebird Club',
        'Join now for full access to member profiles and more',
        'Full community access',
        'Travel tips and local information',
        'Meet new liked-minded people ',
        'Join Club',
        'Already have an account? ',
        'Log in',
        'Book or Host via Homestays',
      ]

      const getTranslation = async (pageData, popupPageData, languageValue) => {
        const translatedText = await textTranslation(pageData, languageValue)
        const translatedText2 = await textTranslation(
          popupPageData,
          languageValue
        )
        this.setState({
          userData: translatedText,
          popupContent: translatedText2,
        })
      }
      const shouldTranslateLang = shouldTranslateTo()
      if (shouldTranslateLang != 'en') {
        getTranslation(pageData, popupPageData, shouldTranslateLang)
      } else {
        this.setState({
          userData: pageData,
          popupContent: popupPageData,
        })
      }
    }

    const {
      match: { params },
    } = this.props
    axios
      .get(`/api/users/${params.id}`)
      .then((response) => {
        const user = response.data.data

        if (
          user.status !== 'approved' &&
          user.status !== 'completed' &&
          user.status !== 'approvedfinal'
        ) {
          this.props.history.push('/search?seeking=locals')
        }

        this.setState({ user })
        if (user.place) {
          axios
            .get(`/api/user/place/${params.id}`)
            .then((response) => {
              this.setState({ place: response.data.data })
            })
            .catch(function (error) {
              console.log('Request failure: ', error)
            })
        }
        getPricing()
      })
      .catch(function (error) {
        console.log('Request failure: ', error)
      })
  }

  handleSendMessage() {
    const auth = this.props.auth.user
    if (auth.status === 'approved' || auth.status === 'approvedfinal') {
      //this.props.history.push(`/send-message/${this.state.user.id}`);
      this.props.history.push(
        `/dashboard/community2?lp=user-${this.state.user.circleId}`
      )
    } else {
      Notification({
        type: INFO,
        message: `To message ${this.state.user.forename} please complete your profile or wait for administrator approval`,
      })
    }
  }

  render() {
    const u = this.state.user
    const place = this.state.place
    const authUser = this.props.auth.user
    const location = authUser ? `${u.city}, ${u.country}` : `${u.country}`

    if (!this.state.userData || !u) {
      return null
    }

    const UserAboutMeSection = ({ content }) => {
      const [readMore, setReadMore] = React.useState(content.length >= 300)
      const textMax = 300

      return (
        <div className={``}>
          <p
            className={`card-text text-black font-open-sans font-weight-400 font-size-16 ${
              readMore ? 'blur-gradient' : ''
            }`}
          >
            {readMore ? content.slice(0, textMax) + '...' : content}
          </p>
          {content.length >= 300 && (
            <div className="flex-center">
              <button
                onClick={() => {
                  setReadMore(!readMore)
                }}
                className="btn-read-more"
              >
                {readMore ? 'Read More' : 'Read Less'}
                <i
                  className={`fa fa-chevron-up ${
                    readMore ? 'fa-rotate-180' : ''
                  }`}
                ></i>
              </button>
            </div>
          )}
        </div>
      )
    }

    return (
      <section id="userProfile" className="main-wrapper">
        {console.log({ authUser })}
        {!authUser && (
          <Popup
            popupContent={this.state.popupContent}
            profilePhoto={u.profilePhotoL}
          />
        )}
        <div
          className="container"
          style={{ zIndex: `${!authUser ? '-1' : '1'}` }}
        >
          {u && authUser && authUser.id == u.id && <Menu active="profile" />}
          <div className="row">
            <div className="col-12 col-md-9 section-left">
              {u && authUser && authUser.id == u.id && (
                <Link to="/dashboard/edit-identity" className="d-md-none">
                  <button className="btn btn-block btn-edit-profile btn-grey text-black mb-3 font-open-sans font-weight-700 font-size-16">
                    <i className="fa fa-pencil-alt"></i>
                    {decode(this.state.userData[0])}
                  </button>
                </Link>
              )}
              <div
                className="card card-user mb-3 border-0"
                style={{ width: '100%' }}
              >
                <div className="row no-gutters">
                  <div
                    className="col-md-5 image-container text-center"
                    style={{
                      display: 'flex',
                      'justify-content': 'center',
                    }}
                  >
                    <div className="image-box">
                      <img
                        src={s3AwsEndpoint + '/' + u.profilePhotoL}
                        onError={(e) => {
                          e.target.onError = null
                          e.target.src =
                            '/images/listing/profile-coming-soon.png'
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="card-body px-0">
                      <div className="text-content text-center text-md-left">
                        <h5 className="card-title text-black font-all-round font-weight-700">
                          {decode(this.state.userData[1])}
                          &nbsp;
                          {authUser ? u.full_name : u.forename}
                        </h5>
                        <p className="card-text font-open-sans font-weight-400 font-size-22">
                          {decode(this.state.userData[4])} {location}
                        </p>
                        <div className="d-flex justify-content-center justify-content-md-start">
                          {this.state.user.isHost ? (
                            <span className="badge i-am-a-host">
                              <img src="/images/icons/i-am-a-host.svg" alt="" />
                              {decode(this.state.userData[2])}
                            </span>
                          ) : (
                            <span className="badge i-am-a-local">
                              <img
                                src="/images/icons/example-profile.svg"
                                alt=""
                              />
                              {decode(this.state.userData[3])}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <MediaQuery maxWidth={776}>
                <RightSection
                  u={u}
                  place={place}
                  authUser={authUser}
                  handleSendMessage={this.handleSendMessage}
                  price={this.state.priceData}
                  translated={this.state.userData}
                />
              </MediaQuery>
              <div className="container">
                <div className="row">
                  {/* ABOUT ME */}
                  <div className="col-12 p-0 m-0">
                    <MediaQuery minWidth={777}>
                      <div
                        className="card card-grey border-0 mb-3"
                        style={{ width: '100%' }}
                      >
                        <div className="card-body">
                          <h5 className="card-title text-black font-all-round font-weight-600 mb-3">
                            {decode(this.state.userData[8])}
                          </h5>
                          <UserAboutMeSection
                            content={this.state.userData[9]}
                          />
                          {/* <p className='card-text text-black font-open-sans font-weight-400 font-size-16'>
                                                        {decode(this.state.userData[9])}
                                                    </p> */}
                        </div>
                      </div>
                    </MediaQuery>
                  </div>

                  <div className="col-12 col-md-4 px-md-0">
                    <MediaQuery maxWidth={776}>
                      <div id="accordion">
                        <div
                          className="card accordion-card card-grey border-0 my-1 mb-3"
                          style={{ width: '100%' }}
                        >
                          <div className="card-header" id="headingOne">
                            <h5
                              className="card-title text-black font-all-round font-weight-600 my-1 text-left"
                              data-toggle="collapse"
                              data-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                            >
                              {decode(this.state.userData[8])}
                              <img
                                className="float-right arrow"
                                src="/images/icons/arrow.svg"
                                alt=""
                              />
                            </h5>
                          </div>
                          <div
                            id="collapseOne"
                            className="collapse show"
                            aria-labelledby="headingOne"
                            data-parent="#accordion"
                          >
                            <div className="card-body pt-0">
                              <p className="card-text text-black font-open-sans font-weight-400 font-size-16">
                                {strLimit(decode(this.state.userData[9]), 600)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </MediaQuery>

                    {/* END ABOUT ME */}

                    {/* INTERESTS */}

                    {this.state.userData[11] && (
                      <MediaQuery minWidth={777}>
                        <div
                          className="card card-grey border-0 mb-3"
                          style={{ width: '100%' }}
                        >
                          <div className="card-body">
                            <h5 className="card-title text-black font-all-round font-weight-600 mb-3">
                              Interests
                            </h5>
                            <p className="card-text text-black font-open-sans font-weight-400 font-size-16">
                              {strLimit(decode(this.state.userData[11]))}
                            </p>
                          </div>
                        </div>
                      </MediaQuery>
                    )}

                    {this.state.userData[11] && (
                      <MediaQuery maxWidth={776}>
                        <div id="accordion">
                          <div
                            className="card accordion-card card-grey border-0 my-1 mb-3"
                            style={{
                              width: '100%',
                            }}
                          >
                            <div className="card-header" id="headingOne">
                              <h5
                                className="card-title text-black font-all-round font-weight-600 my-1 text-left"
                                data-toggle="collapse"
                                data-target="#collapseTwo"
                                aria-expanded="true"
                                aria-controls="collapseTwo"
                              >
                                {decode(this.state.userData[10])}
                                <img
                                  className="float-right arrow"
                                  src="/images/icons/arrow.svg"
                                  alt=""
                                />
                              </h5>
                            </div>
                            <div
                              id="collapseTwo"
                              className="collapse show"
                              aria-labelledby="headingTwo"
                              data-parent="#accordion"
                            >
                              <div className="card-body pt-0">
                                <p className="card-text text-black font-open-sans font-weight-400 font-size-16">
                                  {decode(this.state.userData[11])}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </MediaQuery>
                    )}

                    {/* END INTERESTS */}

                    {/* PHILOSOPHY */}

                    {this.state.userData[11] && (
                      <MediaQuery minWidth={777}>
                        <div
                          className="card card-grey border-0 mb-3"
                          style={{ width: '100%' }}
                        >
                          <div className="card-body">
                            <h5 className="card-title text-black font-all-round font-weight-600 mb-3">
                              {decode(this.state.userData[12])}
                            </h5>
                            <p className="card-text text-black font-open-sans font-weight-400 font-size-16">
                              {decode(this.state.userData[13])}
                            </p>
                          </div>
                        </div>
                      </MediaQuery>
                    )}

                    {this.state.userData[11] && (
                      <MediaQuery maxWidth={776}>
                        <div id="accordion">
                          <div
                            className="card accordion-card card-grey border-0 my-1 mb-3"
                            style={{
                              width: '100%',
                            }}
                          >
                            <div className="card-header" id="headingOne">
                              <h5
                                className="card-title text-black font-all-round font-weight-600 my-1 text-left"
                                data-toggle="collapse"
                                data-target="#collapseThree"
                                aria-expanded="true"
                                aria-controls="collapseThree"
                              >
                                {decode(this.state.userData[12])}
                                <img
                                  className="float-right arrow"
                                  src="/images/icons/arrow.svg"
                                  alt=""
                                />
                              </h5>
                            </div>
                            <div
                              id="collapseThree"
                              className="collapse show"
                              aria-labelledby="headingThree"
                              data-parent="#accordion"
                            >
                              <div className="card-body pt-0">
                                <p className="card-text text-black font-open-sans font-weight-400 font-size-16">
                                  {decode(this.state.userData[13])}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </MediaQuery>
                    )}
                  </div>

                  {/* END PHILOSOPHY */}

                  {/* LANGUAGES */}

                  {this.state.userData[11] && (
                    <div className="col-12 col-md-4 pr-md-0">
                      {u.languages.length > 0 && (
                        <div
                          className="card card-grey border-0 mb-3"
                          style={{
                            width: '100%',
                          }}
                        >
                          <div className="card-body">
                            <h5 className="card-title text-black font-all-round font-weight-600 mb-3">
                              <i className="fa fa-globe"></i>{' '}
                              {decode(this.state.userData[14])}
                            </h5>
                            {u.languages.map(function (language) {
                              return (
                                <p className="card-text text-black font-open-sans font-weight-400 font-size-16">
                                  {language}
                                </p>
                              )
                            })}
                          </div>
                        </div>
                      )}

                      {/* END LANGUAGES */}

                      <div
                        className="card card-grey border-0 mb-3"
                        style={{ width: '100%' }}
                      >
                        <div className="card-body">
                          <h5 className="card-title text-black font-all-round font-weight-600 mb-3">
                            {decode(this.state.userData[15])}
                          </h5>
                          <p className="card-text text-black font-open-sans font-weight-400 font-size-16">
                            {decode(this.state.userData[16])}
                          </p>
                        </div>
                      </div>
                      {u.favoVisitedPlace && (
                        <div
                          className="card card-grey border-0 mb-3"
                          style={{
                            width: '100%',
                          }}
                        >
                          <div className="card-body">
                            <h5 className="card-title text-black font-all-round font-weight-600 mb-3">
                              {decode(this.state.userData[17])}
                            </h5>
                            <p className="card-text text-black font-open-sans font-weight-400 font-size-16">
                              {decode(this.state.userData[18])}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {this.state.userData[11] && (
                    <div className="col-12 col-md-4 pr-md-0">
                      <div id="accordion">
                        <div
                          className="card accordion-card card-grey border-0 my-1 mb-3"
                          style={{
                            width: '100%',
                          }}
                        >
                          <div className="card-header" id="headingOne">
                            <h5
                              className="card-title text-black font-all-round font-weight-600 my-1 text-left"
                              data-toggle="collapse"
                              data-target="#collapseFour"
                              aria-expanded="true"
                              aria-controls="collapseFour"
                            >
                              {decode(this.state.userData[19])}
                              <img
                                className="float-right arrow"
                                src="/images/icons/arrow.svg"
                                alt=""
                              />
                            </h5>
                          </div>
                          <div
                            id="collapseFour"
                            className="collapse show"
                            aria-labelledby="headingFour"
                            data-parent="#accordion"
                          >
                            <div className="card-body pt-0">
                              {u.favoBook && (
                                <p className="card-text text-black font-open-sans font-weight-400">
                                  <span className="font-size-14">
                                    {decode(this.state.userData[20])}
                                  </span>{' '}
                                  <br />
                                  <span className="font-size-16">
                                    {u.favoBook}
                                  </span>
                                </p>
                              )}
                              {u.favoActor && (
                                <p className="card-text text-black font-open-sans font-weight-400">
                                  <span className="font-size-14">
                                    {decode(this.state.userData[21])}
                                  </span>{' '}
                                  <br />
                                  <span className="font-size-16">
                                    {u.favoActor}
                                  </span>
                                </p>
                              )}
                              {u.favoFilm && (
                                <p className="card-text text-black font-open-sans font-weight-400">
                                  <span className="font-size-14">
                                    {decode(this.state.userData[22])}
                                  </span>{' '}
                                  <br />
                                  <span className="font-size-16">
                                    {u.favoFilm}
                                  </span>
                                </p>
                              )}
                              {u.favoFood && (
                                <p className="card-text text-black font-open-sans font-weight-400">
                                  <span className="font-size-14">
                                    {decode(this.state.userData[23])}
                                  </span>{' '}
                                  <br />
                                  <span className="font-size-16">
                                    {u.favoFood}
                                  </span>
                                </p>
                              )}
                              {u.favoMusician && (
                                <p className="card-text text-black font-open-sans font-weight-400">
                                  <span className="font-size-14">
                                    {decode(this.state.userData[24])}
                                  </span>{' '}
                                  <br />
                                  <span className="font-size-16">
                                    {u.favoMusician}
                                  </span>
                                </p>
                              )}
                              {u.favoExercise && (
                                <p className="card-text text-black font-open-sans font-weight-400">
                                  <span className="font-size-14">
                                    {decode(this.state.userData[25])}
                                  </span>{' '}
                                  <br />
                                  <span className="font-size-16">
                                    {u.favoExercise}
                                  </span>
                                </p>
                              )}
                              {u.favoHero && (
                                <p className="card-text text-black font-open-sans font-weight-400">
                                  <span className="font-size-14">
                                    {decode(this.state.userData[26])}
                                  </span>{' '}
                                  <br />
                                  <span className="font-size-16">
                                    {u.favoHero}
                                  </span>
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {!this.state.userData[11] && (
                  <div className="row">
                    <MediaQuery minWidth={777}>
                      {/* LANGUAGES */}
                      <div className="col-12 p-0 m-0">
                        {u.languages.length > 0 && (
                          <div
                            className="card card-grey border-0 mb-3"
                            style={{
                              width: '100%',
                            }}
                          >
                            <div className="card-body">
                              <h5 className="card-title text-black font-all-round font-weight-600 mb-3">
                                <i className="fa fa-globe"></i>{' '}
                                {decode(this.state.userData[14])}
                              </h5>
                              {u.languages.map(function (language) {
                                return (
                                  <p className="card-text text-black font-open-sans font-weight-400 font-size-16">
                                    {language}
                                  </p>
                                )
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    </MediaQuery>

                    <MediaQuery maxWidth={776}>
                      <div className="col-12 col-md-4 px-md-0">
                        <div id="accordion">
                          <div
                            className="card accordion-card card-grey border-0 my-1 mb-3"
                            style={{
                              width: '100%',
                            }}
                          >
                            <div className="card-header" id="headingOne">
                              <h5
                                className="card-title text-black font-all-round font-weight-600 my-1 text-left"
                                data-toggle="collapse"
                                data-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                              >
                                {decode(this.state.userData[14])}
                                <img
                                  className="float-right arrow"
                                  src="/images/icons/arrow.svg"
                                  alt=""
                                />
                              </h5>
                            </div>
                            <div
                              id="collapseOne"
                              className="collapse show"
                              aria-labelledby="headingOne"
                              data-parent="#accordion"
                            >
                              <div className="card-body pt-0">
                                {u.languages.map(function (language) {
                                  return (
                                    <p className="card-text text-black font-open-sans font-weight-400 font-size-16">
                                      {language}
                                    </p>
                                  )
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </MediaQuery>

                    {/* END LANGUAGES */}
                  </div>
                )}
              </div>
            </div>
            <MediaQuery minWidth={777}>
              <RightSection
                u={u}
                place={place}
                authUser={authUser}
                handleSendMessage={this.handleSendMessage}
                price={this.state.priceData}
                translated={this.state.userData}
              />
            </MediaQuery>
          </div>
        </div>
      </section>
    )
  }
}

const RightSection = (props) => {
  const { u, place, authUser, handleSendMessage } = props
  return (
    <div className="col-12 col-md-3 section-right mb-3 px-md-0">
      {u.status == 'approvedfinal' ? (
        <div className="sticky-bar">
          <div
            className="card card-thinking card-grey border-0 mb-3"
            style={{ width: '100%' }}
          >
            <div className="card-body">
              <span class="verified-badge">
                <span>
                  <span aria-label="✅" aria-hidden="true">
                    ✅
                  </span>
                </span>
                <span>ID Verified</span>
              </span>
              <h5 className="card-title font-all-round font-weight-600 font-size-20 pb-2">
                {decode(props.translated[27])}
              </h5>

              {authUser && u && authUser.id == u.id ? (
                <div>
                  <p className="card-text font-open-sans pb-3 font-size-16">
                    {decode(props.translated[28])}
                  </p>
                  <Link
                    to="/dashboard/edit-identity"
                    className="btn btn-block btn-orange text-white text-decoration-none"
                  >
                    {decode(props.translated[29])}
                  </Link>
                </div>
              ) : !authUser ? (
                <div>
                  <p className="card-text font-open-sans pb-3 font-size-16">
                    {decode(props.translated[30])}{' '}
                    <Link to="/how-it-works">
                      {decode(props.translated[31])}
                    </Link>
                    .
                  </p>
                  <Link
                    to="/signup"
                    className="btn btn-block btn-orange text-white text-decoration-none"
                  >
                    {decode(props.translated[32])}
                  </Link>
                </div>
              ) : (
                <div>
                  <p className="card-text font-open-sans pb-3 font-size-16">
                    {decode(props.translated[33])}
                  </p>
                  {u.genderPreference == 'womenonly' ? (
                    <div className="genderInfo">
                      <img src="/images/women-only.png" alt="Women Only" />
                      <p>{decode(props.translated[34])}</p>
                    </div>
                  ) : (
                    u.genderPreference == 'menonly' && (
                      <div className="genderInfo">
                        <img src="/images/men-only.png" alt="Men Only" />
                        <p>{decode(props.translated[35])}</p>
                      </div>
                    )
                  )}

                  <button
                    className="btn btn-block btn-orange text-white text-decoration-none"
                    onClick={handleSendMessage}
                  >
                    {decode(props.translated[36])}
                  </button>
                </div>
              )}
            </div>
          </div>
          {u.isHost ? (
            <div
              className="card card-stay-place border-0"
              style={{ width: '100%' }}
            >
              <img
                className="card-img-top"
                src={`${s3AwsEndpoint}/${place.cover}`}
                alt={place.cover_description}
                onError={(e) => {
                  e.target.onError = null
                  e.target.src = '/images/home/find-homestays.png'
                }}
              />
              <div className="card-body">
                <h5 className="card-title pb-3">
                  {decode(props.translated[37])}
                </h5>
                <p className="card-text pb-3 d-none d-md-block font-size-16">
                  {authUser && u && authUser.id == u.id
                    ? decode(props.translated[38])
                    : strLimit(decode(props.translated[39]), 200)}
                </p>
                <Link
                  to={`/place/${place.id}`}
                  className="btn btn-block btn-orange text-white text-decoration-none"
                >
                  {decode(props.translated[40])}
                </Link>
              </div>
            </div>
          ) : (
            <div
              className="card card-thinking card-grey border-0 mb-3 hidden"
              style={{ width: '100%' }}
            >
              <div className="card-body">
                <h5 className="card-title font-all-round font-weight-600 font-size-20 pb-2">
                  {decode(props.translated[41])}
                </h5>
                <p className="card-text font-open-sans pb-3 font-size-16">
                  {decode(props.translated[42])}
                </p>
                <Link
                  to="/search?seeking=homestays"
                  className="btn btn-block btn-orange text-white text-decoration-none"
                >
                  {decode(props.translated[43])}
                </Link>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="sticky-bar">
          <div
            className="card card-thinking card-grey border-0 mb-3"
            style={{ width: '100%' }}
          >
            <div className="card-body">
              <span class="verified-badge">
                <span>
                  <span aria-label="❎" aria-hidden="true">
                    ❎
                  </span>
                </span>
                <span>Not Yet ID Verified</span>
              </span>

              <div>
                <p className="card-text verified-text font-open-sans pb-3 font-size-16">
                  This member is not yet ID verified and is therefore not
                  contactable via direct messaging. In order to keep Freebird as
                  safe as possible for all members, only members who are
                  ID-verified can participate in direct messaging.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default withSearch(withAuth(User))
